import React from 'react'
import { useParams } from 'react-router-dom'

import PageHeader from '../../components/PageHeader'
import { getTranslate } from '../../localization'
import { AccommodationAddHeader } from './AccommodationAddHeader'
import AccommodationMainForm from './AccommodationMainForm'

type Level = {
  label: string
  link?: string
}
interface AccommodationFormProps {
  levels?: Level[]
  loading?: boolean
}

const AccommodationForm: React.FC<AccommodationFormProps> = ({
  levels,
  loading
}) => {
  const { id } = useParams<{ id: string }>()
  return (
    <div>
      <PageHeader title={getTranslate('Accommodations From')} />
      {!id && <AccommodationAddHeader levels={levels} loading={loading} />}
      <AccommodationMainForm />
    </div>
  )
}

export default AccommodationForm
